import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from "react-redux";
import { alertActions, breadcrumbsActions, userActions as myActions } from "../../../_services/essentials/store";

import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import EditNoteIcon from '@mui/icons-material/EditNote';
import Pagination from '@mui/material/Pagination';
import { history } from "../../../_services/essentials/helpers";
import AddIcon from '@mui/icons-material/Add';

import CircularProgress from '@mui/material/CircularProgress';
export { List };

function List() {
    //    const entity_name = "user";
    //    const entity_label = "User";
    const entities_name = "users";
    const entities_label = "Users";
    const listAPIResponse = useSelector(x => x.users?.listAPIResponse);

    const [loading, setLoading] = useState(true);
    const [entities, setEntities] = useState([]);
    const [totalPages, setTotalPages] = useState('');

    useEffect(() => {
        if (listAPIResponse &&
            listAPIResponse.value &&
            Array.isArray(listAPIResponse.value.list)) {
            setEntities(listAPIResponse.value.list);
            setTotalPages(listAPIResponse.value.totalPages);
            setLoading(false);
        }
    }, [listAPIResponse]);

    //    const totalItems = listAPIResponse?.value?.totalItems;
    const dispatch = useDispatch();
    dispatch(breadcrumbsActions.setCurrentTitle(entities_label));

    const { customerId } = useParams();

    const [dataFilter, setDataFilter] = useState({
        "userFilter": {
            "customerId": customerId
        }
    });

    const [sortModel, setSortModel] = React.useState([
        {
            field: 'firstname',
            sort: 'asc',
        }
    ]);

    const [pageFilter, setPageFilter] = useState({
        "pageNumber": 1,
        "pageSize": 50,
        sortField: sortModel[0]?.field || 'firstname',
        sortDirection: sortModel[0]?.sort || 'asc',
        "dataFilter": dataFilter
    });

    useEffect(() => {
        setEntities([]);
            setDataFilter({
                "userFilter": {
                    "customerId": customerId
                }
            });
    }, [customerId]);

    useEffect(() => {
        setPageFilter({
            ...pageFilter,
            "dataFilter": dataFilter
        })
    }, [dataFilter]);

    // useEffect(() => {
    //     setEntities([]);
    //     setPageFilter({
    //         ...pageFilter,
    //         "pageNumber": 1,
    //         "pageSize": 50,
    //         sortField: sortModel[0]?.field || 'firstname',
    //         sortDirection: sortModel[0]?.sort || 'asc',
    //     });
    // }, [sortModel]);

    useEffect(() => {
        setLoading(true);
        dispatch(myActions.getPaginatedList(pageFilter));
    }, [dispatch, pageFilter]);

    const updatePageFilter = (updates = {}) => {
        setPageFilter((prev) => ({
            ...prev,
            ...updates,
        }));
    };

    function navigatePage(event, newPageNumber) {
        setLoading(true);
        setPageFilter({
            ...pageFilter, // copy the current properties of "json"
            "pageNumber": newPageNumber // update the "name" property
        });
    }

    function showDetails(selectedId) {
        history.navigate(`/${entities_name}/edit/${selectedId}`);
    }

    function taggoleStatusId(currnetStatusId) {
        if (currnetStatusId === 1) {
            return 2;
        } else {
            return 1;
        }
    }

    function taggoleStatusName(currnetStatusId) {
        if (currnetStatusId === 1) {
            return "Deactivate";
        } else {
            return "Activate";
        }
    }

    async function handleStatus(userId, toggledStatusId) {
        try {
            let message;
            message = await dispatch(myActions.updateUserAccountStatus({ userId, toggledStatusId })).unwrap(); //TODO: Add comfirmation
            dispatch(alertActions.success({ message, showAfterRedirect: false }));
            dispatch(myActions.getPaginatedList(pageFilter));
        } catch (error) {
            dispatch(alertActions.error(error));
        }
    }

    const columns = [
        // { field: 'id',
        //     renderHeader: () => (<h6><strong>{'#'}</strong></h6>),
        //     flex: 1,
        //     minWidth: 5,
        //     // renderCell: (params) =>
        //     //     <Link href={`/${entities_name}/edit/${params.row.id}`}>{params.value}</Link>
        // },
        {
            field: 'firstname',
            renderHeader: () => (<h6><strong>{'First Name'}</strong></h6>),
            flex: 1,
            minWidth: 15,
            renderCell: (params) =>
                <Typography sx={{ fontSize: '14px', mt: 1.5, cursor: 'pointer' }} onClick={() => showDetails(params?.row?.id)} >{params?.value}</Typography>
        },
        {
            field: 'lastname',
            renderHeader: () => (<h6><strong>{'Last Name'}</strong></h6>),
            flex: 1,
            minWidth: 15,
            renderCell: (params) =>
                <Typography sx={{ fontSize: '14px', mt: 1.5, cursor: 'pointer' }} onClick={() => showDetails(params?.row?.id)} >{params?.value}</Typography>
        },
        {
            field: 'email',
            renderHeader: () => (<h6><strong>{'Email'}</strong></h6>),
            headerAlign: 'center',
            align: 'center',
            flex: 1,
            minWidth: 100,
            renderCell: (params) =>
                <Typography sx={{ fontSize: '14px', mt: 1.5, cursor: 'pointer' }} onClick={() => showDetails(params?.row?.id)} >{params?.value}</Typography>
        },
        {
            field: 'phone',
            renderHeader: () => (<h6><strong>{'Phone'}</strong></h6>),
            headerAlign: 'center',
            align: 'center',
            flex: .7,
            minWidth: 50,
            renderCell: (params) =>
                <Typography sx={{ fontSize: '14px', mt: 1.5, cursor: 'pointer' }} onClick={() => showDetails(params?.row?.id)} >{params?.value}</Typography>
        },
        {
            field: 'accountStatus',
            renderHeader: () => (<h6><strong>{'Status'}</strong></h6>),
            headerAlign: 'center',
            align: 'center',
            flex: 1,
            minWidth: 30,
            renderCell: (params) =>
                <Typography sx={{ fontSize: '14px', mt: 1.5, cursor: 'pointer' }} onClick={() => showDetails(params?.row?.id)} >{params?.value?.name}</Typography>
        },
        {
            field: 'actions',
            renderHeader: () => (<h6><strong>{'Actions'}</strong></h6>),
            headerAlign: 'center',
            align: 'right',
            flex: 1,
            minWidth: 250,
            sortable: false,
            renderCell: (params) => (
                <Stack direction="row" spacing={1} sx={{ mb: 0.5, mt: 0.5 }} >
                    <Button variant="outlined" size="small" endIcon={<EditNoteIcon />}
                        // href={`/${entities_name}/edit/${params.row.id}`} >
                        onClick={() => history.navigate(`/${entities_name}/edit/${params?.row?.id}`)}>

                        Edit
                    </Button>
                    <Button variant="outlined" size="small" sx={{ width: 120 }}
                        onClick={() => handleStatus(params?.row?.id, taggoleStatusId(params?.row?.accountStatus?.id))}>
                        {taggoleStatusName(params?.row?.accountStatus?.id)}
                    </Button>
                </Stack>
            )
        }
    ];

    return (
        <Box sx={{ width: '100%', minWidth: { sm: '100%', } }}>
            <Stack direction="column" sx={{ flexGrow: '1', gap: 1, ml: 2 }} spacing={2} >
                <Stack direction="row" sx={{ flexGrow: '1', gap: 1, justifyContent: 'right' }} spacing={4} >
                    {/* <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
                        <ArrowLeftIcon onClick={() => history.navigate(-1)} sx={{ fontSize: '48px', mb: 0.5, cursor: 'pointer' }} />{entities_label}
                    </Typography> */}
                    <Typography component="h2" variant="h6" sx={{}}>
                        <Button onClick={() => history.navigate(`/${entities_name}/add`)} variant="contained" color="primary"
                            size="small" endIcon={<AddIcon />}>
                            Add New User
                        </Button>
                    </Typography>
                </Stack>
                <Stack direction="column" sx={{flexGrow: '1', gap: 1}}>
                    <Grid container spacing={2} columns={12}>
                        <Grid size={{md: 12, lg: 12}}>
                            <DataGrid
                                autoHeight
                                // checkboxSelection
                                disableColumnMenu
                                disableColumnFilter
                                disableColumnSelector
                                disableColumnResize
                                hideFooterPagination={true}
                                rows={entities}
                                columns={columns}
                                getRowClassName={(params) =>
                                    (params && params.indexRelativeToCurrentPage % 2 === 0) ? 'even' : 'odd'
                                }
                                onStateChange={(newState) => {
                                    if (newState && newState.page) {
                                        setLoading(false);
                                    }
                                }}
                                sx={{
                                    border: 0,
                                    '& .MuiDataGrid-topContainer': {
                                        color: '#fff', // Text color
                                        // border: 0
                                    },
                                }}
                                sortingMode="server"
                                sortingOrder={['asc', 'desc']}
                                sortModel={sortModel}
                                onSortModelChange={(newSortModel) => {
                                    setLoading(true);
                                    setSortModel(newSortModel);
                                    updatePageFilter({
                                        sortField: newSortModel[0]?.field,
                                        sortDirection: newSortModel[0]?.sort,
                                        pageNumber: 1
                                    });
                                }}
                                initialState={{}}
                                loading={loading}
                                components={{
                                    LoadingOverlay: CircularProgress,
                                }}
                                slotProps={{
                                    loadingOverlay: {
                                        variant: 'skeleton',
                                        // noRowsVariant: 'skeleton',
                                    },
                                }}
                            />
                        </Grid>
                    </Grid>
                    {(totalPages > 1) &&
                    <Pagination variant="outlined" color="primary" count={totalPages} page={pageFilter.pageNumber}
                                onChange={navigatePage}/>
                    }
                </Stack>
            </Stack>
        </Box>
    );
}
